import { render } from "./ChevronUp.vue?vue&type=template&id=c726a7f4"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__